import React from 'react'
import classNames from 'classnames'

type StandardFavoriteCardSkeletonProps = {
  className?: string
  showImage?: boolean
}

export const StandardFavoriteCardSkeleton: React.FC<StandardFavoriteCardSkeletonProps> = ({
  className: classNameFromProps,
  showImage = true,
}) => {
  return (
    <div
      className={classNames(
        'flex flex-col rounded-md overflow-hidden bg-bg-subtle',
        showImage ? 'p-2' : 'p-4',
        classNameFromProps,
      )}
    >
      {showImage && (
        <div className="animate-pulse relative w-full aspect-[16/9] overflow-hidden bg-neutral-90 mb-2 rounded-sm"></div>
      )}
      <div className="animate-pulse relative w-1/2 h-5 mb-2 bg-neutral-90 rounded-sm"></div>
      <div className="animate-pulse relative w-3/4 h-3 mb-1 bg-neutral-90 rounded-sm"></div>
      <div className="animate-pulse relative w-2/3 h-3 bg-neutral-90 rounded-sm"></div>
    </div>
  )
}
